import $ from 'jquery';
import _ from 'underscore';

export class Webdav {
  static editInOffice(data: any): void {
    try {
      var protocol = Webdav.getOfficeProtocol(data.webdavUrl);
      if (protocol) {
        var url: any = protocol + ':ofe|u|' + data.webdavUrl;
        (<any>window).location = url;
        return;
      }
    }
    catch (e) {
      if (!data.failSilently)
        alert('Editing in Office not supported.');
    }
  }

  static getOfficeProtocol(url: string): string {
    var extension = Webdav.getFileNameExtension(url);
    var protocol;
    if (_.contains(["doc", "dot", "docx", "docm", "dotx", "dotm"], extension.toLowerCase())) {
      protocol = 'ms-word';
    }
    else if (_.contains(["xls", "xlt", "xlsx", "xlsm", "xltx", "xltm", "xlsb"], extension.toLowerCase())) {
      protocol = 'ms-excel';
    }
    else if (_.contains(["pptx", "pptm", "ppt", "potx", "potm", "pot", "pps", "ppsx", "ppsm", "ppt", "pptx"], extension.toLowerCase())) {
      protocol = 'ms-powerpoint';
    }

    return protocol;
  }

  static getFileNameWithExtension(filename: string): string {
    var slashIndex = filename.lastIndexOf('\\');
    return slashIndex >= 0 ? filename.substring(slashIndex + 1) : filename;
  }

  static getFileNameExtension(filename: string): string {
    var withExtension = Webdav.getFileNameWithExtension(filename);
    var lastDotIndex = withExtension.lastIndexOf('.');
    return lastDotIndex >= 0 ? withExtension.substring(lastDotIndex + 1) : "";
  }
}